import React, { Component } from 'react';
import { Label, Row, Col, Input, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class CustomerWorkflowsManagementStyle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            clientId: parseInt(this.props.selector) > 0 ? this.props.selector : 0,
            data: [],
            sheetData: [],
            clientList: this.props.filterClients()
        };

        this.headers = ['Company Name', 'Workflow Name', 'Workflow Description', 'Steps', 'Duration'];
    }

    componentDidMount() {
        this.props.log('CustomerWorkflowsManagementStyle.js/componentDidMount');
        if (this.state.clientId > 0) this.onSubmit();
        this.props.filterClientsCallback(() => {
            this.setState({
                clientList: this.props.filterClients()
            })
        });
    }

    onSubmit = () => {
        this.props.log('CustomerWorkflowsManagementStyle.js/onSubmit');
        fetch('/api/reports/CustomerWorkflowsManagementStyle', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
                { key: 'clientId', type: 'int', value: this.state.clientId }
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        isLoaded: true,
                        data: results.data
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.log('CustomerWorkflowsManagementStyle.js/getCSVdata');
        const retArr = [[]];
        this.headers.forEach(header => {
            retArr[0].push(header);
        });
        this.state.data.forEach(item => {
            retArr.push([item.name, item.workflowName, item.workflowDescription, item.workflowTaskName, item.duration]);
        });
        this.props.passData(retArr, "customer-workflows-management-style");
    }

    onChange = (e) => {
        this.props.log('CustomerWorkflowsManagementStyle.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.props.changeSelector(e);
        this.setState({ clientId: e.target.value }, () => this.onSubmit())
    }

    render() {
        this.props.info('CustomerWorkflowsManagementStyle.js/render');
        return (
            <><Row className="mb-4">
                <Col md={12} className="px-1 noPrint">
                    <Label>Company
                        <Input type="select" className="companySelect" name="clientId" value={this.props.isFieldNull(this.state.clientId)} onChange={(e) => this.onChange(e)}>
                            <option value="0">Select</option>
                            {this.state.clientList.filter(client => client.active).map(client => (
                                <option key={client.id} value={this.props.isFieldNull(client.id)}>{client.client}</option>
                            ))}
                        </Input>
                    </Label>
                </Col>
            </Row>
                {this.state.data.length > 0 ?
                    <Table>
                        <thead>
                            <tr>
                                {this.headers.map((header, headerIndex) => (
                                    <th key={headerIndex}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.map((item, itemIndex) => (
                                <tr key={itemIndex}>
                                    <td>{item.name}</td>
                                    <td>{item.workflowName}</td>
                                    <td>{item.workflowDescription}</td>
                                    <td>{item.workflowTaskName}</td>
                                    <td>{item.duration}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table> : <>{this.state.isLoaded ? "No Results" : ""}</>}
            </>
        );
    }
}

export default CustomerWorkflowsManagementStyle;
